import React from 'react';
import classNames from "classnames";
import styles from './XTextEdit.module.scss';
import { ETheme } from '../../types/enums/ETheme';
import { XControl } from '../commons/XControl';
import { IControlState } from '../commons/IControlState';
import { IControlProps } from '../commons/IControlProps';

//////////////////////////////////////////////////
// interface ITextEditProps
//////////////////////////////////////////////////
export interface ITextEditProps extends IControlProps {
    theme?: ETheme;
    onClick?: (owner: XTextEdit) => void;
}

//////////////////////////////////////////////////
// interface ITextEditState
//////////////////////////////////////////////////
export interface ITextEditState extends IControlState {
    theme: ETheme;
}

//////////////////////////////////////////////////
// class XTextEdit
//////////////////////////////////////////////////
export class XTextEdit extends XControl<HTMLDivElement, ITextEditProps, ITextEditState> {
    //////////////////////////////////////////////////
    static defaultProps = {
        ...XControl.defaultProps,
        theme: ETheme.Blue
    }
    //////////////////////////////////////////////////
    public constructor(props: ITextEditProps) {
        super(props);
        this.state = {
            ...this.state,
            theme: this.props.theme === undefined
                ? ETheme.Red
                : this.props.theme
        };
        this.onClick = this.onClick.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
    }
    //////////////////////////////////////////////////
    componentDidMount(): void{
        super.componentDidMount();
    }
    //////////////////////////////////////////////////
    componentWillUnmount(): void{
        super.componentWillUnmount();
    }
    //////////////////////////////////////////////////
    onClick(): void {this.props.onClick?.(this);};
    //////////////////////////////////////////////////
    onKeyDown(event: React.KeyboardEvent<HTMLDivElement>): void {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    }
    //////////////////////////////////////////////////
    render(): React.ReactNode {
        return (
            <div ref={this.reference} className={classNames(styles.XTextEdit)}>
                <div className={styles.XEdit} contentEditable="true" onKeyDown={this.onKeyDown}/>
            </div>
        );
    }
    //////////////////////////////////////////////////
}
